import { FC, ReactElement, ReactNode } from 'react'
import cn from 'classnames'

import styles from 'components/features/rewards/rewardsPane/components/CryptoRewardsOrderDetailsField/CryptoRewardsOrderDetailsField.styl'

type CryptoRewardsOrderDetailsFieldProps = {
  label: ReactNode
  value: ReactNode
  className?: string
}

export const CryptoRewardsOrderDetailsField: FC<CryptoRewardsOrderDetailsFieldProps> = ({
  label,
  value,
  className,
}): ReactElement => (
  <div className={ cn(styles.container, className) }>
    <h6 className={ styles.label }>{ label }</h6>
    <p className={ styles.value }>{ value }</p>
  </div>
)
